export const ADMIN_TYPE_ADMIN = 'Admin';

export const ADMIN_TYPE_MEMBER = 'Member';

// Alias for members to keep UI consistent
export const ADMIN_TYPE_EVERYONE = ADMIN_TYPE_MEMBER;
